module.exports = __webpack_public_path__ + "static/media/what-is-pkt.d78a1b54.svg";